__turbopack_context__.v({
  "calloutBody": "PerformanceLabInternationalPricingCallout-module__EK-IcW__calloutBody",
  "calloutRoot": "PerformanceLabInternationalPricingCallout-module__EK-IcW__calloutRoot",
  "calloutText": "PerformanceLabInternationalPricingCallout-module__EK-IcW__calloutText",
});
